// The carousel renders each slide up to three times (for its seamless loop), and the cart
// banner remounts every time the drawer opens - deduping by banner per page view keeps
// promo_view to one per banner actually seen, rather than one per mounted copy.
const viewedPromoKeys = new Set<string>();

/**
 * Records that the promo identified by `promoKey` was viewed on the current page view.
 * @returns Whether this is the first view of it on this page view, i.e. whether to track it.
 */
export const markPromoViewed = (promoKey: string): boolean => {
  if (viewedPromoKeys.has(promoKey)) {
    return false;
  }
  viewedPromoKeys.add(promoKey);
  return true;
};

/** Starts a new page view, so every promo can be tracked again. */
export const resetPromoViews = () => {
  viewedPromoKeys.clear();
};
